import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NMObjectUploadPopup } from "@neumetric/blueprint-lib/flows";
import SourceTemplate from "../../../assets/others/Mitigator_Controller_Upload_Template-Source.csv";
import ThreatTypeTemplate from "../../../assets/others/Mitigator_Controller_Upload_Template-ThreatType.csv";
import ThreatTemplate from "../../../assets/others/Mitigator_Controller_Upload_Template-Threat.csv";
import VulnerabilityTemplate from "../../../assets/others/Mitigator_Controller_Upload_Template-Vulnerability.csv";
import AssetTemplate from "../../../assets/others/Mitigator_Controller_Upload_Template-Asset.csv";
import AssetTypeTemplate from "../../../assets/others/Mitigator_Controller_Upload_Template-AssetType.csv";
import ReferenceTemplate from "../../../assets/others/Mitigator_Controller_Upload_Template-Reference.csv";
import { mitigatorActions, getImportResult } from "../../../store";

const TITLE_BY_KEY = {
  "import-source": "Upload Source",
  "import-threat-type": "Upload Threat Type",
  "import-threat": "Upload Threat",
  "import-vulnerability": "Upload Vulnerability",
  "import-asset": "Upload Asset",
  "import-asset-type": "Upload Asset Type",
  "import-reference": "Upload Reference",
};
const OBJECT_BY_KEY = {
  "import-source": "Source",
  "import-threat-type": "Threat Type",
  "import-threat": "Threat",
  "import-vulnerability": "Vulnerability",
  "import-asset": "Asset",
  "import-asset-type": "Asset Type",
  "import-reference": "Reference",
};
const stepsTemplateMapping = {
  "import-source": "Source",
  "import-threat-type": "Threat Type",
  "import-threat": "Threat",
  "import-vulnerability": "Vulnerability",
  "import-asset": "Asset",
  "import-asset-type": "Asset Type",
  "import-reference": "Reference",
};
const ACCEPT_BY_KEY = {
  "import-source": ".csv,.xls,.xlsx",
  "import-threat": ".csv,.xls,.xlsx",
  "import-vulnerability": ".csv,.xls,.xlsx",
  "import-asset": ".csv,.xls,.xlsx",
  "import-asset-type": ".csv,.xls,.xlsx",
  "import-reference": ".csv,.xls,.xlsx",
};
const TEMPLATE_FILE_BY_KEY = {
  "import-source": SourceTemplate,
  "import-threat-type": ThreatTypeTemplate,
  "import-threat": ThreatTemplate,
  "import-vulnerability": VulnerabilityTemplate,
  "import-asset": AssetTemplate,
  "import-asset-type": AssetTypeTemplate,
  "import-reference": ReferenceTemplate,
};
const UPLOAD_ACTION_BY_KEY = {
  "import-source": mitigatorActions.importSource,
  "import-threat-type": mitigatorActions.importThreatType,
  "import-threat": mitigatorActions.importThreat,
  "import-vulnerability": mitigatorActions.importVulnerability,
  "import-asset": mitigatorActions.importAsset,
  "import-asset-type": mitigatorActions.importAssetType,
  "import-reference": mitigatorActions.importReference,
};

function getLabel(menuKey) {
  return stepsTemplateMapping[menuKey] || "Object";
}

function getSteps(menuKey) {
  const label = getLabel(menuKey);
  return [
    "Download the template provided below.",
    `Prepare existing ${label} using this Template.`,
    `Import prepared ${label} when ready!`,
  ];
}

function getTemplate(menuKey) {
  const label = getLabel(menuKey);
  const safe = label.replace(/\s+/g, "_");

  return {
    name: `Mitigator_Controller_Upload_Template-${safe}.csv`,
    path: TEMPLATE_FILE_BY_KEY[menuKey], // <-- bundle-generated URL
  };
}

export const ImportPopup = ({ open, onClose, menuKey }) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const dispatch = useDispatch();
  const importResult = useSelector(getImportResult);
  const title = TITLE_BY_KEY[menuKey] || "Upload Objects";
  const objectName = OBJECT_BY_KEY[menuKey];
  const steps = getSteps(menuKey);
  const template = getTemplate(menuKey);
  const accept = ACCEPT_BY_KEY[menuKey] || ".csv,.xls,.xlsx";

  React.useEffect(() => {
    if (open) {
      dispatch(mitigatorActions.clearImportResult());
    }
  }, [open]);

  const handleClose = () => {
    setIsSubmitting(false);
    if (onClose) onClose();
  };

  const handleUploadConfirm = (files) => {
    if (!files || !files.length) return;

    const rawFile = files[0];
    const file = rawFile.originFileObj || rawFile;

    const actionCreator = UPLOAD_ACTION_BY_KEY[menuKey];
    if (!actionCreator) return;

    setIsSubmitting(true);

    dispatch(actionCreator({ file }));
  };

  return (
    <NMObjectUploadPopup
      key={open ? "open" : "closed"}
      visible={open}
      onModalClose={handleClose}
      onUploadConfirm={handleUploadConfirm}
      isSubmitting={isSubmitting}
      result={importResult}
      steps={steps}
      template={template}
      accept={accept}
      multiple={false}
      title={title}
      maskClosable={false}
      objectName={objectName}
    />
  );
};
